module.exports = __webpack_public_path__ + "img/zoom0Tile.aa827dcb.png";